import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import style from "./SkillsEdit.module.css";
import { baseurl } from "../Url";
import { MdEdit, MdWorkOutline } from "react-icons/md";
import Loader from "../Loder/Loader";

const SkillsEdit = () => {
  const navigate = useNavigate();
  const USERID = localStorage.getItem("USERID");
  const OrgID = localStorage.getItem("ORGID");
  const [loading, setLoading] = useState(true);
  const [skills, setSkills] = useState([]);
  const [workExperience, setWorkExperience] = useState([]);

  useEffect(() => {
    if (USERID && OrgID) {
      fetchSkillsList();
      fetchWorkExperience();
    } else {
      setLoading(false);
    }
  }, [USERID, OrgID]);

  async function fetchSkillsList() {
    try {
      const response = await fetch(`${baseurl}/candidate/skills/list`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          user_id: USERID,
          org_id: OrgID,
        }),
      });

      const data = await response.json();
      
      if (data.status === true && data.data) {
        setSkills(Array.isArray(data.data) ? data.data : []);
      } else {
        console.error("Failed to fetch skills:", data.description || "Unknown error");
        setSkills([]);
      }
    } catch (error) {
      console.error("Error fetching skills list:", error);
      setSkills([]);
    } finally {
      setLoading(false);
    }
  }

  async function fetchWorkExperience() {
    try {
      const response = await fetch(`${baseurl}/candidate/profile/get`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          user_id: USERID,
        }),
      });

      const data = await response.json();
      
      if (data.status === true && data.data && data.data.length > 0) {
        const profile = data.data[0];
        if (profile.work_experience && Array.isArray(profile.work_experience)) {
          setWorkExperience(profile.work_experience);
        }
      }
    } catch (error) {
      console.error("Error fetching work experience:", error);
    }
  }

  const formatSkillName = (skill) => {
    return skill
      .split(/\s+/)
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };

  const handleEditSkill = (skill) => {
    // Navigate to edit-skill page
    navigate("/profile/edit-skill", { state: { skill: skill, skillName: skill } });
  };

  if (loading && skills.length === 0) {
    return <Loader />;
  }

  return (
    <div className={style.container}>
      <div className={style.pageContent}>
        {/* Skills List */}
        <div className={style.skillsListContainer}>
          {skills.length > 0 ? (
            skills.map((skill, index) => (
              <div key={index} className={style.skillCard}>
                <div className={style.skillCardContent}>
                  <div className={style.skillHeader}>
                    <h3 className={style.skillTitle}>{formatSkillName(skill)}</h3>
                    <button 
                      className={style.editIconButton}
                      onClick={() => handleEditSkill(skill)}
                      title="Edit skill"
                    >
                      <MdEdit />
                    </button>
                  </div>
                  {workExperience.length > 0 && (
                    <div className={style.skillExperienceRow}>
                      <div className={style.experienceIcon}>
                        <MdWorkOutline />
                      </div>
                      <span className={style.experienceText}>
                        {workExperience[0].role} at {workExperience[0].company}
                      </span>
                    </div>
                  )}
                </div>
              </div>
            ))
          ) : (
            <div className={style.emptyState}>
              <p>No skills added yet</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SkillsEdit;

